import { Environment, type EnvironmentLabel } from './environment';

export enum LoggerLevel {
  LOCAL = 1,
  DEVELOPMENT = 2,
  FEATURE = 3,
  ATEST = 4,
  PTEST = 5,
  TREASURY_STAGING = 6,
  PRODUCTION = 7
}

export type LoggerConfig = { level: LoggerLevel; name: Environment };

export type LogLevelConfig = Record<EnvironmentLabel, LoggerConfig>;

export const LogLevelConfiguration: LogLevelConfig = {
  Local: {
    level: LoggerLevel.LOCAL,
    name: Environment.Local
  },
  Development: {
    level: LoggerLevel.DEVELOPMENT,
    name: Environment.Development
  },
  Feature: {
    level: LoggerLevel.FEATURE,
    name: Environment.Feature
  },
  Atest: {
    level: LoggerLevel.ATEST,
    name: Environment.Atest
  },
  PTest: {
    level: LoggerLevel.PTEST,
    name: Environment.PTest
  },
  TreasuryStaging: {
    level: LoggerLevel.TREASURY_STAGING,
    name: Environment.TreasuryStaging
  },
  Production: {
    level: LoggerLevel.PRODUCTION,
    name: Environment.Production
  }
} as const;
